import getListItems from "@/api/get-list-items"

export async function fetchListItems(listCode: string) {
  const { status, data } = await getListItems.call({
    queryParams: { list_code: listCode },
  })

  if (status !== 200) {
    throw new Error("Failed to fetch list items")
  }

  return data
}
